import React from "react";
import { Image } from "react-native";

const EmbeddedIMage = ({ node }) => {
    const imageUrl = `https:${node.data.url}`;
    const { width, height } = node.data.dimensions as {
        width: number;
        height: number;
    };
    const windowWidth = 500;
    const aspectRatio = width / height;
    const imageWidth = windowWidth;
    const imageHeight = windowWidth / aspectRatio;

    return (
        <Image
            source={{
                uri: imageUrl,
            }}
            style={{
                width: imageWidth,
                height: imageHeight,
                marginLeft: -20,
                marginBottom: 20,
                resizeMode: "contain",
            }}
        />
    );
};

export default EmbeddedIMage;
